import React, { FC } from 'react';
import Show from '../Show/Show';
import { SPACING } from '../../config/designSystem/Spacing';
import { Title1 } from '../../config/designSystem/typography';
import { View } from 'react-native';

interface PageTitleProps {
    title: string;
    element?: React.ReactNode;
  }

const PageTitle: FC<PageTitleProps> = ({title, element}) => {
  return (
    <View style={{flexDirection: 'row', justifyContent:'space-between', alignItems:'center'}}>
      <View style={{maxWidth: '80%'}}>
        <Title1>
          {title}
        </Title1>
      </View>
      <Show when={element}>
        <View style={{
          marginLeft: SPACING['sp-16'],
          width: SPACING['sp-32'],
          height:SPACING['sp-32'],
          justifyContent: 'center',
        }}>
          {element}
        </View>
      </Show>

    </View>  );
};



export default PageTitle;